<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">CanPay Merchant Buyer's Group</h1>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <!-- MunchMakers Card -->
            <div class="card">
              <div class="card-body">
                <div class="benefit-card">
                  <div class="benefit-logo-section">
                    <img src="../assets/images/munchmakers-logo.webp" alt="MunchMakers" class="benefit-logo" />
                  </div>
                  <hr class="manage-horizontal">
                  <div>
                    <p class="adjust-margin make-text-bold adjust-font-size">
                      MunchMakers
                    </p>
                  </div>
                  <div class="mt-3 ml-2 mr-2 mb-3">
                    <p class="benefit-highlight-text make-text-bold-1 adjust-font-size-1">
                      MunchMakers is a custom cannabis accessories studio, offering top-tier solutions to increase your sales and grow your brand. They provide premium branded products that your customers will actually use on a daily basis.
                    </p>
                  </div>
                  <div class="mt-3 ml-2 mr-2 mb-3">
                    <p class="benefit-highlight-text make-text-bold-1 adjust-font-size-1">
                      Custom Grinders. Custom Rolling Trays. Custom Ashtrays. Custom Vape Pens. Custom Rolling Papers. And more.
                    </p>
                  </div>
                  <div class="mt-3 ml-2 mr-2 mb-3">
                    <p class="offer-section-title make-text-bold adjust-font-size">
                      CanPay Merchant Buyer's Group Deal:
                    </p>
                    <p class="benefit-highlight-text make-text-bold-1 adjust-font-size-1">
                      10% discount on all orders $10k or smaller. Larger discounts on larger orders/repeat orders.
                    </p>
                  </div>
                  <div class="mt-3 mb-3">
                    <button class="learn-more-button-css mb-2" @click="redirectToMunchMakers()">
                      I want more details
                      <svg class="abjust-arrow-position" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 25 42" fill="none">
                        <path d="M24.0047 19.3612L5.31415 0.67097C4.88186 0.23834 4.30479 0 3.68948 0C3.07417 0 2.4971 0.23834 2.06481 0.67097L0.688385 2.04706C-0.207266 2.94373 -0.207266 4.40109 0.688385 5.2964L16.3833 20.9913L0.67097 36.7036C0.238681 37.1362 0 37.713 0 38.3279C0 38.9436 0.238681 39.5203 0.67097 39.9533L2.0474 41.329C2.48003 41.7617 3.05676 42 3.67207 42C4.28738 42 4.86445 41.7617 5.29674 41.329L24.0047 22.6218C24.438 22.1878 24.676 21.6083 24.6746 20.9923C24.676 20.3739 24.438 19.7948 24.0047 19.3612Z" fill="white"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
    data(){
        return {
            munchMakersLink: 'https://canpay.munchmakers.com/b2b/' // Placeholder for the link to be updated later
        }
    },
    methods:{
        redirectToMunchMakers(){
            let self = this;
            // Placeholder link - to be updated when final link is received from client
            const link = self.munchMakersLink || '#';
            if (link !== '#') {
                window.open(link, '_blank');
            } else {
                // For now, just log that the link needs to be updated
                console.log('MunchMakers link needs to be updated');
                // You can show a message to the user or handle this differently
                alert('Link will be available soon. Please contact support for more details.');
            }
        }
    }
}
</script>

<style scoped>
.benefit-card {
  text-align: center;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 20px;
}

.benefit-logo-section {
  width: 100%;
  background-color: #EFEFEF;
  border-radius: 12px 12px 0px 0px;
  padding: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -20px -20px 0 -20px;
}

.benefit-logo {
  max-width: 300px;
  max-height: 150px;
  width: auto;
  height: auto;
  object-fit: contain;
}

.manage-horizontal{
    margin-top: 20px;
    margin-bottom: 20px;
    border: 0.1px solid rgba(0, 0, 0, 0.1);
}

.adjust-margin{
    margin-bottom: 0px;
}

.make-text-bold{
    font-weight: bolder;
}

.make-text-bold-1{
    font-weight: 500;
}

.adjust-font-size{
    font-size: 1.2rem;
}

.adjust-font-size-1{
    font-size: 1rem;
}

/* CSS */
.learn-more-button-css {
  min-width: 220px;
  align-items: center;
  appearance: none;
  background-color: #1e4a7d;
  background-image: linear-gradient(1deg, #1e4a7d, #1e4a7d 99%);
  background-size: calc(100% + 20px) calc(100% + 20px);
  border-radius: 100px;
  border-width: 0;
  box-shadow: none;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-flex;
  font-family: CircularStd,sans-serif;
  font-size: 1rem;
  height: auto;
  justify-content: center;
  line-height: 1.5;
  padding: 6px 20px;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: all 0.3s ease;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
}

.learn-more-button-css:active,
.learn-more-button-css:focus {
  outline: none;
}

.learn-more-button-css:hover {
  background-position: -20px -20px;
}

.learn-more-button-css:focus:not(:active) {
  box-shadow: rgba(40, 170, 255, 0.25) 0 0 0 .125em;
}

.abjust-arrow-position{
    position:relative;
    right:-8px;
    margin-left: 8px;
}

.benefit-highlight-text {
  padding-left: 1rem;
  padding-right: 1rem;
  text-align: center;
  line-height: 1.6;
  margin: 0.75rem 0;
  color: #333333;
}

.offer-section-title {
  padding-left: 1rem;
  padding-right: 1rem;
  text-align: center;
  color: #1e4a7d;
  margin-bottom: 0.5rem;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.ml-2 {
  margin-left: 0.5rem !important;
}

.mr-2 {
  margin-right: 0.5rem !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.text-center {
  text-align: center !important;
}
</style>


